export default __webpack_public_path__ + "c6e2053303524e39530c36f094129407.svg";